import { render, staticRenderFns } from "./ProductCategorySelect.vue?vue&type=template&id=88d97940&"
import script from "./ProductCategorySelect.vue?vue&type=script&lang=js&"
export * from "./ProductCategorySelect.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategorySelect.vue?vue&type=style&index=0&id=88d97940&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports